<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>위험성평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업내용</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>평가일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_2" />
        </div>
        <div>
          <div>실시기간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }} ~ {{ form.inputA_4 }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputA_3" :readonly="board.readonly" @change="checkDate(form.inputA_3)" />
            ~
            <date-selector v-model="form.inputA_4" :readonly="board.readonly" @change="checkDate(form.inputA_4)" />
          </div>
        </div>

        <div>
          <div>예정공정표 첨부</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_5.fileName }}
          </p>
          <file-uploader :readonly="board.readonly" v-else v-model="form.inputA_5" />
        </div>
        <div>
          <div>평가마감일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_6 }} </span>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_6" />
        </div>

      </div>
    </div>

    <table-risk-assembly-record
      :board="board"
      :is-print="isPrint"
      title="위험성평가 회의록"
      thema="label"
      :is-add-row="true"
      :is-remove-row="true"
      :multiple="true"
      :is-value-convert="true"
      :tableData="[
        { id: 'cell1', title: '공종명(필수)', type: 'text', placeholder: '내용' },
        { id: 'cell2', title: '세부작업내용', type: 'textarea', placeholder: '내용' },
        {
          id: 'cell3',
          title: '평가구분',
          type: 'select',
          selectData: valueTypeList,
          placeholder: '선택',
        },
        { id: 'cell4', title: '유해·위험요인', type: 'customType', selectData: [], placeholder: '선택', },
        { id: 'cell5', title: '재해형태', type: 'customType', selectData: [], placeholder: '내용' },
        { id: 'cell6', title: '현재 안전보건조치', type: 'textarea', placeholder: '내용' },
        { id: 'cell7', title: '현재 위험도', type: 'customType', placeholder: '내용' },
        { id: 'cell8', title: '위험감소대책', type: 'textarea', placeholder: '내용' },
        { id: 'cell9', title: '개선후 위험도', type: 'risk', placeholder: '내용' },
      ]"
      :mobile="['cell1', 'cell3', 'cell4']"
      v-model="form.checkList_1"
    >
      <template #headButton>
        <vs-button class="mr-4" type="border" color="secondary" @click="showPrevBoard671=true">위험성평가 회의록 불러오기</vs-button>
      </template>
      <template #customType="{ cellData, trData, value, input }">
        <div v-if="cellData && cellData.id === 'cell4'">
          <div v-if="isPrint">
            <span class="print-input">{{ trData.cell4 }}</span>
          </div>
          <div v-else>
            <ml-input v-if="!!trData && !!trData.cell3 && (!valueTypeList.includes(trData.cell3) || trData.cell3 === '기타')" class="w-full" v-model="trData.cell4" />
            <vs-select v-else-if="!!trData && !!trData.cell3" class="w-full" autocomplete v-model="trData.cell4" :disabled="board.readonly">
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in handleAppraisalType(trData.cell3)" />
              <vs-select-item v-show="false" :value="trData.cell4" :text="trData.cell4" />
            </vs-select>
            <vs-select v-else class="w-full"></vs-select>
          </div>
        </div>
        <div v-else-if="cellData && cellData.id === 'cell5'">
          <span v-if="isPrint" class="print-input">{{ getString(trData.cell5) }}</span>
          <disaster-class-selector v-else v-model="trData.cell5" :readonly="board.readonly" :multiple="true" />
        </div>
        <div v-else-if="cellData && cellData.id === 'cell7'">
          <span v-if="isPrint" class="print-input">{{ trData.cell7 }}</span>
          <ml-input v-else v-model="trData.cell7" class="w-full" :style="{ color: trData.riskColor }" />
        </div>
      </template>
    </table-risk-assembly-record>

    <table-risk-assembly-record
      :board="board"
      :is-print="isPrint"
      title="안전·보건관리자 검토의견"
      thema="label"
      :is-add-row="true"
      :is-remove-row="true"
      :multiple="true"
      :is-value-convert="true"
      :tableData="[
        { id: 'cell1', title: '공종명(필수)', type: 'text', placeholder: '내용' },
        { id: 'cell2', title: '세부작업내용', type: 'textarea', placeholder: '내용' },
        { id: 'cell3', title: '검토의견', type: 'textarea', placeholder: '내용'},
        { id: 'cell4', title: '검토의견 반영 위험도', type: 'risk' },
        { id: 'cell5', title: '검토자', type: 'text', placeholder: '내용' },
        { id: 'cell6', title: '비고', type: 'textarea', placeholder: '내용' },
      ]"
      v-model="form.checkList_2"
      :mobile="['cell1', 'cell3', 'cell5']"
    />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="신축현장 점검" />

    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoListAfter" :is-print="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="신축현장 점검" />

    <!-- 확인자 -->
    <div v-if="!isPrint" class="mt-28px">
      <div>
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>담당자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>관리감독자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />

    <popup-load-prev-board v-model="showPrevBoard671" :setBoardId="671" @selectRowData="(data) => selectRowData(671, data)" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import TableRiskAssemblyRecord from "@/components/TableRiskAssemblyRecord.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    DisasterClassSelector,
    TableRiskAssemblyRecord,
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.checkList_1': {
      immediate: true,
      deep: true,
      handler(value) {
        for(let index = 0; index < value.length; index++) {
          this.form.checkList_2[index].cell1 = value[index].cell1
        }
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  mounted() {
    if (this.projectId === 2) {
      this.valueTypeList = [
        '기계적 요인',
        '전기적 요인',
        '화학적 요인',
        '생물학적 요인',
        '작업특성 요인',
        '작업환경 요인',
        '기타',
      ]
    }
  },
  data() {
    return {
      showPrevBoard671: false,
      valueTypeList: [
        '기계(설비)적 요인',
        '전기적 요인',
        '화학(물질)적 요인',
        '생물학적 요인',
        '작업특성 요인',
        '작업환경 요인',
        '직접입력',
      ],
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {}, // file
        inputA_6: "",

        inputC_1: "",
        inputC_2: "",

        checkList_1: [],
        checkList_2: [],
        photoList: [],
        photoListAfter: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        fileList: [],
      },
    };
  },
  methods: {
    handleAppraisalType(type) {
      if (this.projectId === 2) {
        if (type === "기계적 요인") {
          return ["추락(사람이 떨어짐)", "낙하(물건이 떨어짐)", "전도(사람‧물건의 넘어짐, 미끄러짐)", "비래(날아오는 물체에 맞음)", "붕괴(건물‧물체의 무너짐)", "협착(깔리거나 끼임)", "충돌(부딪힘)", "절단, 베임, 찔림"];
        } else if (type === "전기적 요인") {
          return ["감전/누전", "전기불꽃", "화재/폭발", "과열"];
        } else if (type === "화학적 요인") {
          return ["기체 : 가스, 증기 등", "액체 : 미스트, 에어로졸 등", "고체 : 흄, 분진 등"];
        } else if (type === "생물학적 요인") {
          return ["병원성 미생물, 바이러스", "유전자 변형물질", "동식물"];
        } else if (type === "작업특성 요인") {
          return ["소음, 진동", "종사자 실수", "이상압력 및 밀폐공간", "온도(고온, 저온)", "중량물취급", "반복작업", "불안정한 작업자세", "작업(조작)도구"];
        } else if (type === "작업환경 요인") {
          return ["이상기온(고온/한랭)", "조도(조명)", "작업공간 정리정돈", "이동통로", "주변종사자", "무리한 작업시간"];
        } else if (type !== "") {
          return ["직접입력"];
        }
      }
      else {
        if (type === "기계(설비)적 요인") {
          return ["끼임(감김)", "위험한 표면(절단, 베임, 긁힘)", "기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분", "충돌위험 부분", "넘어짐(미끄러짐, 걸림, 헛디딤)", "추락위험 부분(개구부 등)", "기타", "직접입력"];
        } else if (type === "전기적 요인") {
          return ["감전(안전전압초과)", "아크", "정전기", "화재 / 폭발 위험", "기타", "직접입력"];
        } else if (type === "화학(물질)적 요인") {
          return ["가스", "증기", "에어로졸·흄", "액체·미스트", "고체(분진)", "반응성 물질", "방사선", "화재 / 폭발 위험", "복사열 / 폭발과압", "기타", "직접입력"];
        } else if (type === "생물학적 요인") {
          return ["병원성 미생물, 바이러스에 의한 감염", "유전자 변형물질(GMO)", "알러지 및 미생물", "동물", "식물", "기타", "직접입력"];
        } else if (type === "작업특성 요인") {
          return ["소음", "초음파·초저주파음", "진동", "근로자 실수(휴먼에러)", "저압 또는 고압상태", "질식위험·산소결핍", "중량물 취급작업", "반복작업", "불안정한 작업자세", "작업(조작)도구", "기후 / 고온 / 한랭", "기타", "직접입력"];
        } else if (type === "작업환경 요인") {
          return ["기후 / 고온 / 한랭", "조명", "공간 및 이동통로", "주변 근로자", "작업시간", "조직 안전문화", "화상", "작업(조작) 도구", "기타", "직접입력"];
        } else if (type !== "") {
          return ["직접입력"];
        }
      }
    },

    checkDate(input) {
      if (Date.parse(this.form.inputA_3) > Date.parse(this.form.inputA_4)) {
        if (input === this.form.inputA_3) {
          this.form.inputA_4 = this.form.inputA_3;
        } else {
          this.form.inputA_3 = this.form.inputA_4;
        }
      }
    },

    selectRowData(index, data) {
      this.form.checkList_1 = []
      this.form.checkList_2 = []

      if (!data) return
      for(const assembly of data.checkList) {
        let count = this.form.checkList_1.length

        if (assembly.cell7 !== 'O') {
          continue;
        }

        const assemblyData1 = {
          id: ++count,
          cell2: assembly.cell4,
          cell3: assembly.cell1,
          cell4: assembly.cell2,
          cell6: assembly.cell6,
          cell7: assembly.risk3,
          riskColor: assembly.riskColor,
        }
        const assemblyData2 = {
          id: count,
          cell1: assemblyData1.cell1,
          cell2: assemblyData1.cell2,
        }

        this.form.checkList_1.push(assemblyData1)
        this.form.checkList_2.push(assemblyData2)

      }
    },

    getString(data) {
      let result = String(data);
      return result !== 'undefined'? result: '';
    },
  },
};
</script>
